import React from "react";
import AppLoading from "./pages/appLoading";

import "css/root.scss";

import InitialiseSentry from "./errorReporting";
import { createRoot } from "react-dom/client";

document.title = "7fivefive Lens";

InitialiseSentry(window.location.hostname);
console.debug("Sentry env: ", window.location.hostname);

const App = React.lazy(() => import("./App"));

const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(
    <React.Suspense fallback={<AppLoading />}>
        <App />
    </React.Suspense>,
);
